/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PickListEditable = (function () {

    function PickListEditable () {

        Monet.UI.Fields.PickList.apply (this, arguments);

        this.createBaseStructure ();

        this.defaultValue = ' ';
        this.input = null;

        this.setSelectedValue = function (value) {
            if(this.input && this.input.options){
                var options = this.input.options;

                for(var i = 0, length = options.length; i < length;  i++) {
                    var option = options[i];
                    if(option.value.trim() === value.trim()){
                        option.selected = true;
                    }
                }
            }

            this.input.value = value;

        };

        this.getValue = function () {

            if ( this.inputValue ){
                this.value = ( this.inputValue.value ).trim();
            }

            return this.value;
        };

        this.setValue = function (value) {

            this.value = value || '';
            this.selectedValue = this.value;
            this.inputValue.value = Monet.I18n.getResourcesByKey(value || "");
            this.inputValue.setAttribute("valuetosend", value || "");

            this.setSelectedValue(this.value);
        };
    
        this.setInputValue = function (value) {
            this.setValue(value);
        };

        this.clear = function () {
            var clearValue = this.defaultValue || '';
            this.setValue(clearValue);
            this.input.value = clearValue;
        };

        this.render = function () {

            this.inputValue = document.createElement ('input');
            this.inputValue.className = 'value';
            
            this.createElement();
            this.rootEl.className += ' select-editable';
            this.checkPickListTypeAndRequestData (this.successOfRequestData);
            this.rootEl.insertBefore (this.inputValue, this.input);
            
            this.input.addEventListener("change", (function (self) {
                return function () {
                    self.setValue(this.value);
                };
            }(this)));

            return this.rootEl;

        };


    }

    return PickListEditable;

}());